import { THEME } from "@constants/global";
import { useTheme } from "next-themes";
import Image from "next/legacy/image";
import { useState } from "react";

interface RatingProps {
  defaultValue: number;
  max?: number;
  disabled?: boolean;
  onChange?: (value: number) => void;
}

const Rating = ({ defaultValue, onChange, disabled, max = 4 }: RatingProps) => {
  const [rating, setRating] = useState(defaultValue);
  const { theme } = useTheme();

  const handleChange = (index: number) => {
    if (disabled) return;

    // * if rating is 1 and user click on 1 again, reset rating to 0
    if (rating === index && index === 1) {
      setRating(0);
      onChange?.(0);
      return;
    }

    setRating(index);
    onChange?.(index);
  };

  return (
    <div className="flex justify-end rounded-lg p-2 dark:bg-gray-800">
      {[...Array(max)].map((_, index) => (
        <div
          key={index}
          onClick={() => handleChange(index + 1)}
          className="my-auto flex cursor-pointer content-center items-center justify-between"
        >
          {index < rating ? (
            <Image
              src="/icon/brain.svg"
              alt="brain filled"
              width={55}
              height={55}
            />
          ) : (
            <Image
              src={
                theme === THEME.dark
                  ? "/icon/empty-brain.svg"
                  : "/icon/empty-brain-light.svg"
              }
              alt="brain empty"
              width={55}
              height={55}
            />
          )}
          <div
            className={`w-full border-2 ${
              index < rating - 1
                ? "border-blue-500"
                : index < max - 1
                  ? "border-gray-300"
                  : "border-transparent"
            }`}
          />
        </div>
      ))}
    </div>
  );
};

export default Rating;
